import { OfferData } from '../../../core/domain/offerData.model'
import { authUser } from '../../../core/services/auth.service'
import OfferService from '../../../core/services/offer.service'
import {
  existsOfferDocument,
  existsToken,
  saveOfferDocumentId,
  saveToken,
} from '../../../core/services/storage.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { MAX_VEHICLES_INSURED } from '../../_utils/environmentConst.provider'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import { VehiclesInfoValues, VehiclesSection, View } from './Vehicles.view'

export class VehiclesPresenter implements LifecyclePresenter<View> {
  private view!: VehiclesSection
  private stepPageName: string = 'vehicles'
  private stepPageNumber: number = 1
  protected offer: OfferData

  async initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    await this.getOfferDocument()

    const plates = []
    Object.keys(this.offer)
      .filter(v => v.startsWith('plate'))
      .map((plate, i) => {
        if (this.offer[`plate${i + 1}`])
          plates.push(this.offer[`plate${i + 1}`])
      })

    dataLayer.page.category.applicationStep = 'step1-vehicles'
    if (this.offer.progressMask[0] !== '1') {
      AdobeEventManager.emit('CLO Application start', 'calc_open')
    }

    this.view.setInitialValues(
      {
        numberOfVehicles: this.offer.numberOfVehicles,
        vehiclesToEnsure: this.offer.vehiclesToEnsure,
        plates,
      },
      this.offer.progressMask[6] === '1',
    )
  }

  getOfferDocument = async () => {
    try {
      if (!existsOfferDocument() || !existsToken()) {
        const publicAuthObject = await OfferService.initOffer()

        saveOfferDocumentId(publicAuthObject.offerDocumentId)
        saveToken(publicAuthObject.jwtAuthToken)
        await authUser()
      }

      this.offer = await OfferService.getOfferData()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = (formValues: VehiclesInfoValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)

    const spreadPlates = this.deconstructPlateArray(formValues.plates)
    const offerData = this.setFormValues(formValues, spreadPlates)

    OfferService.saveOfferData(offerData).then(() => this.goToNextStep())
  }

  deconstructPlateArray = (plates: string[]) => {
    while (
      plates.length <
      Object.keys(this.offer).filter(v => v.startsWith('plate')).length &&
      plates.length < MAX_VEHICLES_INSURED
    )
      plates.push('')
    return {
      ...plates.reduce(
        (accum, current, index) =>
          Object.assign(accum, {
            [`plate${index + 1}`]: current,
          }),
        {},
      ),
    }
  }

  setFormValues = (formValues: VehiclesInfoValues, spreadPlates: Object) => {
    return Object.assign(this.offer, { ...formValues, ...spreadPlates })
  }

  goToNextStep = () => this.view.props.history.push('/calculator/deductible')

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  onBackToPortal = () => {
    this.view.props.history.push('/portal')
  }

  saveAndRedirect = (formValues: VehiclesInfoValues) => {
    Object.assign(this.offer, { ...formValues })

    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push('/contact-me')
    })
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }
}
